'use strict';
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//
//Imported functions from the library
//
import { 
  // tabTrapping, 
  jquerySlider,
  jqueryTabTrapping,
  moveImageToBg, 
  effectOnScroll, 
  ncrSlider,
  ncrIcons, 
  utils, 
  elementResizer, 
  moveElementAround,
  clickableDiv
} from '@ncr-digital-banking/web-js-lib';

import { customIcons } from './icons.js';
//
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  clickableDiv();
  document.querySelector('.band-menu-panel').classList.add('panel-off-1201','panel-pop');
  document.querySelector('.band-login-panel').classList.add('panel-off-1201','panel-pop');

  var panel2 = document.querySelectorAll('.menu-panel-level-2');
  panel2.forEach(function(element) {
    element.classList.add('switch-accordion-overlay');
  });

  var panel3 = document.querySelectorAll('.menu-panel-level-3');
  panel3.forEach(function(element) {
      element.classList.add('panel-off-1201', 'panel-accordion');
  });

  document.querySelector('header .feature.search [ncr-panel]').classList.add('panel-off-1');

  //font awesome
  FontAwesome.library.add(customIcons, ncrIcons)

  //utils
  utils();

  //resizer
  elementResizer('.resizer');

  elementResizer('.feature-wrap-quicklinks-1',{
    qty: 5,
    minWidth: 270,
  });

  elementResizer('.feature-wrap-promos-1',{
    qty: 3,
  });

  elementResizer('.feature-wrap-rates-1',{
    qty: 3,
    minWidth: 350,
  });

  elementResizer('.feature-wrap-testimonials-1',{
    qty: 4,
  });

  //slider
  ncrSlider(".ncr-slider")
  // jquerySlider('.ncr-slider',{
  //   slider_speed: 9000,
  //   nextArrow: '<span class="icon-utility-caret-right" aria-label="next" role="img"></span>',
  //   prevArrow: '<span class="icon-utility-caret-left" aria-label="previus" role="img"></span>'
  // });


  //cover image
  moveImageToBg('.cover-image',{
    destroyBelow: "",
    detectDistance: 0,
    pushContentDown: false,
    bgType: "cover"//default
  });

  //tabtrap
  // tabTrapping();
  jqueryTabTrapping();


  // console.log(document.querySelector('[ncr-panel="Alert"]'))

  //move utilities
  moveElementAround('header .band-utility-1 .feature-wrap', {
    insideBefore: 'header .band-menu-panel .feature-wrap-menu',
    returnBelow: 1201,  // Width in pixels
  });
  moveElementAround('header .band-utility-2 .feature-wrap', {
    insideBefore: 'header .band-menu-panel .feature-wrap-menu',
    returnBelow: 1201,  // Width in pixels
  });

  moveElementAround('header .band-utility-3 .feature-wrap', {
    insideBefore: 'header .band-menu-panel .feature-wrap-menu',
    returnBelow: 99999,  // Width in pixels
  });
  //effect on scroll
  effectOnScroll('.fixed', {
    detectDistance: 0,
    pushContentDown: true,
    contentToPush: 'main',
    fixed: true,
  });
  
  // effectOnScroll('.feature-padding', {
  //   detectDistance: .7,
  // });

  //Moves Breadcrumbs outside of <main> so that you can have a 2 column layout
   document.querySelectorAll('.col-main div[class*="band-breadcrumbs"]').forEach(function(element) {
    document.querySelector('main').prepend(element);
  });
 

  //Moves Content Hero outside of <main> so that you can have a 2 column layout
  document.querySelectorAll('.col-main div[class*="content-hero"]').forEach(function(element) {
    document.querySelector('main').prepend(element);
  });





 
(function ($) {
  //////////////////////////////////////////////////////////////////////////////
  //Compare Table
  //////////////////////////////////////////////////////////////////////////////
  //

 
  $.fn.basictable = function(options) {
    const setup = function(table, data) {
      const headings = [];
      if (data.tableWrap) {
        table.wrap('<div class="bt-wrapper"></div>');
      }
      if (data.header) {
        let format = "";
        if (table.find("thead tr th").length) {
          format = "thead th";
        } else if (table.find("tbody tr th").length) {
          format = "tbody tr th";
        } else if (table.find("th").length) {
          format = "tr:first th";
        } else {
          format = "tr:first td";
        }
        $.each(table.find(format), (function() {
          const $heading = $(this);
          const colspan = parseInt($heading.attr("colspan"), 10) || 1;
          const row = $heading.closest("tr").index();
          if (!headings[row]) {
            headings[row] = [];
          }
          for (let i = 0; i < colspan; i++) {
            headings[row].push($heading);
          }
        }));
      }
      $.each(table.find("tbody tr"), (function() {
        setupRow($(this), headings, data);
      }));
      $.each(table.find("tfoot tr"), (function() {
        setupRow($(this), headings, data);
      }));
    };
    const setupRow = function($row, headings, data) {
      $row.children().each((function() {
        const $cell = $(this);
        if (($cell.html() === "" || $cell.html() === "&nbsp;") && !data.showEmptyCells) {
          $cell.addClass("bt-hide");
        } else {
          const cellIndex = $cell.index();
          let headingText = "";
          for (let j = 0; j < headings.length; j++) {
            if (j !== 0) {
              headingText += ": ";
            }
            const $heading = headings[j][cellIndex];
            headingText += $heading.html();
          }
          $cell.prepend('<span class="bt-content-th">'+headingText+'</span>')
          if (data.contentWrap && !$cell.children().hasClass("bt-content")) {
            
            $cell.wrapInner('<span class="bt-content" />');
          }
        }
      }));
    };
    const unwrap = function(table) {
      $.each(table.find("td"), (function() {
        const $cell = $(this);
        const content = $cell.children(".bt-content").html();
        $cell.html(content);
      }));
    };
    const check = function(table, data) {
      if (!data.forceResponsive) {
        if (table.removeClass("bt").outerWidth() > table.parent().width()) {
          start(table, data);
        } else {
          end(table, data);
        }
      } else {
        if (data.breakpoint !== null && $(window).width() <= data.breakpoint || data.containerBreakpoint !== null && table.parent().width() <= data.containerBreakpoint) {
          start(table, data);
        } else {
          end(table, data);
        }
      }
    };
    const start = function(table, data) {
      table.addClass("bt");
      if (!data.header) {
        table.addClass("bt--no-header");
      }
      if (data.tableWrap) {
        table.parent(".bt-wrapper").addClass("active");
      }
    };
    const end = function(table, data) {
      table.removeClass("bt bt--no-header");
      if (data.tableWrap) {
        table.parent(".bt-wrapper").removeClass("active");
      }
    };
    const destroy = function(table, data) {
      table.removeClass("bt bt--no-header");
      table.find("td").removeAttr("data-th");
      if (data.tableWrap) {
        table.unwrap();
      }
      if (data.contentWrap) {
        unwrap(table);
      }
      table.removeData("basictable");
    };
    const resize = function(table) {
      if (table.data("basictable")) {
        check(table, table.data("basictable"));
      }
    };
    this.each((function() {
      const table = $(this);
      if (table.length === 0 || table.data("basictable")) {
        if (table.data("basictable")) {
          const data = table.data("basictable");
          if (options === "destroy") {
            destroy(table, data);
          } else if (options === "restart") {
            destroy(table, data);
            table.data("basictable", data);
            setup(table, data);
            check(table, data);
          } else if (options === "start") {
            start(table, data);
          } else if (options === "stop") {
            end(table, data);
          } else {
            check(table, data);
          }
        }
        return false;
      }
      const settings = $.extend({}, $.fn.basictable.defaults, options);
      const vars = {
        breakpoint: settings.breakpoint,
        containerBreakpoint: settings.containerBreakpoint,
        contentWrap: settings.contentWrap,
        forceResponsive: settings.forceResponsive,
        noResize: settings.noResize,
        tableWrap: settings.tableWrap,
        showEmptyCells: settings.showEmptyCells,
        header: settings.header
      };
      if (vars.breakpoint === null && vars.containerBreakpoint === null) {
        vars.breakpoint = 568;
      }
      table.data("basictable", vars);
      setup(table, table.data("basictable"));
      if (!vars.noResize) {
        check(table, table.data("basictable"));
        $(window).bind("resize.basictable", (function() {
          resize(table);
        }));
      }
    }));
  };
  $.fn.basictable.defaults = {
    breakpoint: null,
    containerBreakpoint: null,
    contentWrap: true,
    forceResponsive: true,
    noResize: false,
    tableWrap: false,
    showEmptyCells: false,
    header: true
  };
  

  ///////////////////////////////////////////////////////////////////////////
  //Compare Table end                                          
  ///////////////////////////////////////////////////////////////////////////

    $(document).on('ready', function () {
    $('table').basictable({breakpoint: 900});
  });
   
})(jQuery); // or even jQuery.noConflict()
  
  // // //Moves Blog Header outside of <main> so that you can have a 2 column layout
  // document.querySelectorAll('.col-main div[class*="blog-header"]').forEach(function(element) {
  //   document.querySelector('main').prepend(element);
  // });

  // :::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::   Custom   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::



